/**
 * Prefix patterns that identify every localStorage key owned by this app.
 * Using prefix matching is more robust than maintaining an exhaustive key list —
 * it automatically covers versioned prefixes (e.g. column_filters_v6:) and any
 * new keys added under the same namespaces without requiring updates here.
 *
 *   "app:"           → app:selected_location, app:location_codes, app:autocall_ui,
 *                       app:filter:ac:cities, app:filter:tq:city, etc.
 *   "column_filters" → column_filters_v6:autocall, column_filters_v6:scheduled, etc.
 */
const APP_STORAGE_PREFIXES = ["app:", "column_filters"] as const;

/**
 * Removes all persisted app state from localStorage.
 * Call this on sign-out so the next user gets a clean state.
 */
export function clearAppPersistence(): void {
  try {
    if (typeof localStorage === "undefined") return;
    // Iterate in reverse so removing items doesn't shift the index.
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && APP_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    // ignore
  }
}
